module.exports = __webpack_public_path__ + "static/media/RemoteTeachingDiagram.95ecf931.png";